import { Spinner as Spin } from "react-bootstrap";

interface SpinnerProps {
    variant?:
        | "primary"
        | "secondary"
        | "success"
        | "danger"
        | "warning"
        | "info"
        | "light"
        | "dark"
        | "custom-blue";
    size?: "sm";
}

export function Spinner({ variant, size }: SpinnerProps) {
    return (
        <Spin animation="border" variant={variant || "custom-blue"} size={size} />
    );
}

export function SpinnerSmall() {
    return <Spin size="sm" animation="border" variant="custom-blue" />;
}
